<template>
  <div style="padding: 24px 0">
    <a-input-search placeholder="请输入证书编号" enter-button="查询" size="large" @search="onSearch" v-model="certNo" />
    <div style="margin-top: 24px" v-if="show">
      <a-descriptions bordered title="查询成功" size="small">
        <a-descriptions-item label="证书编号">{{ certNo }}</a-descriptions-item>
        <a-descriptions-item label="设计/制作">宋志海</a-descriptions-item>
        <a-descriptions-item label="工作室">宋志海玉雕工作室</a-descriptions-item>
      </a-descriptions>
      <img :src="imgUrl" style="width: 100%; margin-top: 16px;" alt="作品加载中" />
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';

export default {
  data() {
    return {
      certNo: null,
      show: false,
    };
  },
  created() {
    document.title = "宋志海玉雕工作室";
  },
  watch: {
    certNo() {
      this.show = false;
    },
  },
  computed: {
    imgUrl() {
      return `http://cert.szhyudiao.com/szh/${this.certNo}.jpg`;
    },
  },
  methods: {
    onSearch() {
      if (this.certNo.length < 8) {
        message.error('请输入正确的证书编号！')
        return
      }
      this.show = true;
    },
  },
};
</script>